import { apiFetch } from './client';

export type JoinRequestStatus =
  | 'pending'
  | 'approved'
  | 'denied'
  | 'cancelled';

export interface GroupOption {
  id: string;
  name: string;
  path: string;
  description?: string;
}

export interface GroupJoinRequest {
  id: string;
  userId: string;
  keycloakSub: string;
  groupId: string;
  groupName: string;
  status: JoinRequestStatus;
  note: string | null;
  requestedAt: string;
  decidedAt: string | null;
  decidedByKeycloakSub: string | null;
}

export interface MyGroupsResponse {
  memberOf: GroupOption[];
  available: GroupOption[];
  pendingRequests: GroupJoinRequest[];
}

export interface PendingJoinRequest extends GroupJoinRequest {
  firstName: string;
  lastName: string;
  email: string;
  username: string;
}

export const getMyGroups = async (
  signal?: AbortSignal,
): Promise<MyGroupsResponse> => {
  return apiFetch<MyGroupsResponse>('/users/me/groups', { signal });
};

export const requestToJoinGroup = async (
  groupId: string,
  note?: string,
): Promise<GroupJoinRequest> => {
  return apiFetch<GroupJoinRequest>(
    `/users/me/groups/${encodeURIComponent(groupId)}/request`,
    { method: 'POST', data: note ? { note } : {} },
  );
};

export const cancelJoinRequest = async (
  requestId: string,
): Promise<GroupJoinRequest> => {
  return apiFetch<GroupJoinRequest>(
    `/users/me/groups/requests/${encodeURIComponent(requestId)}`,
    { method: 'DELETE' },
  );
};

// ─── Admin approval ──────────────────────────────────────────────────────────

export const listPendingJoinRequests = async (
  signal?: AbortSignal,
): Promise<{ requests: PendingJoinRequest[] }> => {
  return apiFetch<{ requests: PendingJoinRequest[] }>(
    '/admin/kc/group-requests',
    { signal },
  );
};

export const approveJoinRequest = async (
  requestId: string,
): Promise<GroupJoinRequest> => {
  return apiFetch<GroupJoinRequest>(
    `/admin/kc/group-requests/${encodeURIComponent(requestId)}/approve`,
    { method: 'POST' },
  );
};

export const denyJoinRequest = async (
  requestId: string,
  note?: string,
): Promise<GroupJoinRequest> => {
  return apiFetch<GroupJoinRequest>(
    `/admin/kc/group-requests/${encodeURIComponent(requestId)}/deny`,
    { method: 'POST', data: note ? { note } : {} },
  );
};
